<template>
    <div>
        <div class="card-body">
            <el-form :model="classForm" label-width="90px">
                <el-form-item label="课程学科">
                    <el-input v-model="classPlan.subject_name" disabled></el-input>
                </el-form-item>

                <el-form-item label="任课老师">
                    <el-input v-model="classPlan.teacher_name" disabled></el-input>
                </el-form-item>

                <el-form-item label="上课时间">
                    <el-input v-model="classPlan.time" disabled></el-input>
                </el-form-item>

                <el-form-item label="时长">
                    <el-input v-model="classForm.duration" disabled></el-input>
                </el-form-item>

                <el-form-item label="备注">
                    <el-input v-model="classForm.remark" placeholder="请输入"></el-input>
                </el-form-item>

                <el-form-item label="教室">
                    <el-select v-model="classForm.classroom_id"
                               filterable
                               remote
                               clearable
                               :remote-method="handleSearchClassroom"
                               placeholder="请选择教室">
                        <el-option
                                v-for="item in classrooms"
                                :key="item.id"
                                :label="item.complete_name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="年级">
                    <el-radio-group v-model="classPlan.grade_id" size="mini" disabled>
                        <el-radio-button border v-for="item in $parentInfo.grades" :key="item.id" :label="item.id">
                            {{item.name}}
                        </el-radio-button>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="班级类型">
                    <el-radio-group v-model="classPlan.class_type_id" size="mini" disabled>
                        <el-radio-button :label="1">一对一</el-radio-button>
                        <el-radio-button :label="4">一对二</el-radio-button>
                        <el-radio-button :label="2">一对三</el-radio-button>
                        <el-radio-button :label="6">一对六</el-radio-button>
                        <el-radio-button :label="3">小班</el-radio-button>

                    </el-radio-group>
                </el-form-item>

                <el-form-item label="班型">
                    <el-radio-group v-model="classPlan.type" size="mini" disabled>
                        <el-radio-button :label="1">普通</el-radio-button>
                        <el-radio-button :label="2">衔接</el-radio-button>
                        <el-radio-button :label="3">Ti</el-radio-button>
                        <el-radio-button :label="4" disabled>试听</el-radio-button>
                        <el-radio-button :label="5" disabled>综评辅导</el-radio-button>
                        <el-radio-button :label="6" v-if="$parentInfo.filter.section_id==4">网络</el-radio-button>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="课程名称">
                    <el-input v-model="classPlan.class_name" disabled></el-input>
                </el-form-item>

                <el-form-item label="初始总课次">
                    <el-input v-model="classPlan.original_period" disabled></el-input>
                </el-form-item>

                <el-form-item label="当前总课次">
                    <el-input v-model="classPlan.period" disabled></el-input>
                </el-form-item>

                <el-form-item label="单价">
                    <el-input v-model="classPlan.unit_period_price" disabled></el-input>
                </el-form-item>

                <el-form-item>
                    <!--//原31  测试126-->
                    <el-button size="small" @click="handleStore" :loading="button_loading">修改保存</el-button>
                    <el-button size="small" @click="handleDelete" :loading="$parentInfo.Dialog_UpdateClass.button_loading" v-if="[4,5].includes(classPlan.type) || $parentInfo.powers.includes(32)">刪除</el-button>
                    <el-button size="mini" type="info" @click="handleShowClassPlanTeacherVisit" v-if="powers.indexOf(126)">老师课堂回访</el-button>
                </el-form-item>
            </el-form>
        </div>

        <el-dialog
                title="老师课堂回访"
                :visible.sync="dialogVisible"
                width="30%"
                :modal="false"
                :before-close="handleClose">
            <div>
                <el-input
                        type="textarea"
                        :rows="5"
                        placeholder="请输入内容"
                        v-model="content">
                </el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="updateTeacherVisit" :loading="button_loading">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "Dialog_UpdateClass",
        data() {
            return {
                path: "/timeTable/day",
                powers: [],
                button_loading: false,
                title: '修改课程',
                loading: true,
                classForm: {
                    remark: '',
                    classroom_id: '',
                    duration:'',
                },
                classPlan: {},
                course: {},
                classrooms: '',
                classPlan_id: '',
                dialogVisible: false,
                content: '',
                classPlanTeacherVisit: '',
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.$wApi.addListen(this.path, this.handleData);
            this.handleShowClass();
            this.handleIndexClassroom();
        },
        computed: {},
        methods: {
            handleData(event, data) {
                switch (event) {
                    case 'class_show':
                        this.classPlan = data.classPlan;
                        this.classForm.classroom_id = data.classPlan.classroom_id;
                        this.classForm.remark = data.classPlan.remark;
                        this.classForm.duration=(data.classPlan.end_sort-data.classPlan.start_sort)*60
                        this.loading = false;
                        break;
                    case 'classroom_show':
                        this.classrooms = data.classrooms;
                        break;
                    case 'returnVisit_show':
                        this.classPlanTeacherVisit = data.classPlanTeacherVisit;
                        this.content = this.classPlanTeacherVisit.content;
                        break;
                    case 'returnVisit_update':
                        this.$message({
                            message: '保存回访成功',
                            type: 'success'
                        });
                        this.dialogVisible = false;
                        this.button_loading = false;
                        break;
                    case 'returnVisit_update_error':
                        this.button_loading = false;
                        break;
                    case 'search_classroom':
                        this.classrooms = data.classrooms;
                        break;
                }
            },
            handleShowClass() {
                this.$wApi.send(this.$parentInfo.path, 'class_show', {
                    'class_plan_id': this.$store.state.modal.data.class_plan_id,
                });
            },
            handleStore() {
                this.$wApi.send(this.$parentInfo.path, 'class_update', {
                    'classPlan_id': this.$store.state.modal.data.class_plan_id,
                    'classroom_id': this.classForm.classroom_id,
                    'remark': this.classForm.remark,
                    'teacher_id': this.classPlan.teacher_id,
                    'date': this.classPlan.date,
                    'time': this.classPlan.start_time,
                    'type':'table',
                    'duration': (this.classPlan.end_sort - this.classPlan.start_sort).toFixed(1)
                });
            },
            handleDelete(){
                this.$confirm('该课时若有已买学生，则同时进行学生机构原因退费，确认删除?', '提示', {
                    StartReturn: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$parentInfo.Dialog_UpdateClass.button_loading=true;
                    this.$wApi.send(this.$parentInfo.path, 'classPlan_delete', {
                        'classPlan_id': this.$store.state.modal.data.class_plan_id
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            handleIndexClassroom() {
                this.$wApi.send(this.$parentInfo.path, 'classroom_show', {
                    'classPlan_id': this.$store.state.modal.data.class_plan_id,
                });
            },
            handleSearchClassroom(query) {
                this.$wApi.send(this.$parentInfo.path, 'search_classroom', {
                    'classPlan_id': this.$store.state.modal.data.class_plan_id,
                    'classroom_name': query
                });
            },
            handleGoToMonthlyTimeTable() {
                this.$Win.closeModal();
                this.$Win.openModal('Dialog_MonthlyTable',  1800, 900,this.classPlan.name, {
                    'class_id':this.$store.state.modal.data.class_id
                });
            },
            handleClose() {
                this.$message({
                    message: '未修改老师课堂回访',
                });
                this.dialogVisible = false;
            },
            handleShowClassPlanTeacherVisit() {
                this.dialogVisible=true;
                this.$wApi.send(this.$parentInfo.path, 'returnVisit_show', {
                    'classPlan_id': this.$store.state.modal.data.class_plan_id,
                });
            },
            updateTeacherVisit() {
                this.$wApi.send(this.$parentInfo.path, 'returnVisit_update', {
                    'classPlan_id': this.$store.state.modal.data.class_plan_id,
                    'content': this.content,
                });
            },
            handleClassPlanInformation(){
                this.$parentInfo.Dialog_ClassPlanInformation.classPlan_id=this.$store.state.modal.data.class_plan_id
                this.$Win.openModal('Dialog_ClassPlanInformation', 440, 430,
                    '课堂信息-'+this.classPlan.class_name+'-'+this.classPlan.date,
                    {},true);
            },

        }
    }
</script>

<style scoped>

</style>